/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as Verify2faRouteImport } from './routes/verify-2fa'
import { Route as Setup2faRouteImport } from './routes/setup-2fa'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AcceptInviteRouteImport } from './routes/accept-invite'
import { Route as AdminRouteImport } from './routes/_admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminTransacoesRouteImport } from './routes/_admin/transacoes'
import { Route as AdminSorteiosRouteImport } from './routes/_admin/sorteios'
import { Route as AdminSeoRouteImport } from './routes/_admin/seo'
import { Route as AdminSaudeSistemaRouteImport } from './routes/_admin/saude-sistema'
import { Route as AdminSaquesRouteImport } from './routes/_admin/saques'
import { Route as AdminRelatoriosRouteImport } from './routes/_admin/relatorios'
import { Route as AdminPremiosRouteImport } from './routes/_admin/premios'
import { Route as AdminMeuPerfilRouteImport } from './routes/_admin/meu-perfil'
import { Route as AdminLogsRouteImport } from './routes/_admin/logs'
import { Route as AdminLeadsRouteImport } from './routes/_admin/leads'
import { Route as AdminKycRouteImport } from './routes/_admin/kyc'
import { Route as AdminIpSecurityRouteImport } from './routes/_admin/ip-security'
import { Route as AdminIntegracoesRouteImport } from './routes/_admin/integracoes'
import { Route as AdminFunilRouteImport } from './routes/_admin/funil'
import { Route as AdminFaturamentoRouteImport } from './routes/_admin/faturamento'
import { Route as AdminEquipeRouteImport } from './routes/_admin/equipe'
import { Route as AdminEnviosRouteImport } from './routes/_admin/envios'
import { Route as AdminDestaquesRouteImport } from './routes/_admin/destaques'
import { Route as AdminDashboardRouteImport } from './routes/_admin/dashboard'
import { Route as AdminConfiguracoesRouteImport } from './routes/_admin/configuracoes'
import { Route as AdminCircuitBreakersRouteImport } from './routes/_admin/circuit-breakers'
import { Route as AdminChangePasswordRouteImport } from './routes/_admin/change-password'
import { Route as AdminCampanhasRouteImport } from './routes/_admin/campanhas'
import { Route as AdminBtagsRouteImport } from './routes/_admin/btags'
import { Route as AdminBannersRouteImport } from './routes/_admin/banners'
import { Route as AdminAuditoriaRouteImport } from './routes/_admin/auditoria'
import { Route as AdminAlertasRouteImport } from './routes/_admin/alertas'
import { Route as AdminAfiliadosRouteImport } from './routes/_admin/afiliados'
import { Route as AdminUsuariosIndexRouteImport } from './routes/_admin/usuarios/index'
import { Route as AdminTemasIndexRouteImport } from './routes/_admin/temas/index'
import { Route as AdminSeoIndexRouteImport } from './routes/_admin/seo/index'
import { Route as AdminMediaIndexRouteImport } from './routes/_admin/media/index'
import { Route as AdminJogosIndexRouteImport } from './routes/_admin/jogos/index'
import { Route as AdminAlertasSegurancaIndexRouteImport } from './routes/_admin/alertas-seguranca/index'
import { Route as AdminUsuariosIdRouteImport } from './routes/_admin/usuarios/$id'
import { Route as AdminSorteiosPendentesRouteImport } from './routes/_admin/sorteios/pendentes'
import { Route as AdminSorteiosEncerradosRouteImport } from './routes/_admin/sorteios/encerrados'
import { Route as AdminSeoSlugRouteImport } from './routes/_admin/seo/$slug'
import { Route as AdminSegurancaSessoesRouteImport } from './routes/_admin/seguranca/sessoes'
import { Route as AdminSegurancaIpAllowlistRouteImport } from './routes/_admin/seguranca/ip-allowlist'
import { Route as AdminSaquesManualReviewRouteImport } from './routes/_admin/saques/manual-review'
import { Route as AdminSaquesHistoricoRouteImport } from './routes/_admin/saques/historico'
import { Route as AdminPresentationArchitectureRouteImport } from './routes/_admin/presentation/architecture'
import { Route as AdminMediaPastasRouteImport } from './routes/_admin/media/pastas'
import { Route as AdminJogosTemplatesRouteImport } from './routes/_admin/jogos/templates'
import { Route as AdminJogosNewRouteImport } from './routes/_admin/jogos/new'
import { Route as AdminJogosModalidadesRouteImport } from './routes/_admin/jogos/modalidades'
import { Route as AdminJogosEncerradosRouteImport } from './routes/_admin/jogos/encerrados'
import { Route as AdminJogosCadastradosRouteImport } from './routes/_admin/jogos/cadastrados'
import { Route as AdminJogosAndamentoRouteImport } from './routes/_admin/jogos/andamento'
import { Route as AdminJogosIdRouteImport } from './routes/_admin/jogos/$id'
import { Route as AdminDocsTokensRouteImport } from './routes/_admin/docs/tokens'
import { Route as AdminDocsTemplatesRouteImport } from './routes/_admin/docs/templates'
import { Route as AdminDocsSegurancaRouteImport } from './routes/_admin/docs/seguranca'
import { Route as AdminDocsJogosRouteImport } from './routes/_admin/docs/jogos'
import { Route as AdminDocsAuthRouteImport } from './routes/_admin/docs/auth'
import { Route as AdminDocsApiIntegracaoRouteImport } from './routes/_admin/docs/api-integracao'
import { Route as AdminAlertasEntregasRouteImport } from './routes/_admin/alertas/entregas'
import { Route as AdminAlertasSegurancaPreferenciasRouteImport } from './routes/_admin/alertas-seguranca/preferencias'
import { Route as AdminAlertasSegurancaIdRouteImport } from './routes/_admin/alertas-seguranca/$id'
import { Route as AdminLotepEstruturasIndexRouteImport } from './routes/_admin/lotep/estruturas/index'
import { Route as AdminKycReviewIndexRouteImport } from './routes/_admin/kyc/review/index'
import { Route as AdminTemasPreviewCodeRouteImport } from './routes/_admin/temas/preview.$code'
import { Route as AdminKycReviewIdRouteImport } from './routes/_admin/kyc/review/$id'
import { Route as AdminJogosIdDashboardRouteImport } from './routes/_admin/jogos/$id.dashboard'
import { Route as AdminLotepEstruturasStructureIdPoolRouteImport } from './routes/_admin/lotep/estruturas/$structureId.pool'

const Verify2faRoute = Verify2faRouteImport.update({
  id: '/verify-2fa',
  path: '/verify-2fa',
  getParentRoute: () => rootRouteImport,
} as any)
const Setup2faRoute = Setup2faRouteImport.update({
  id: '/setup-2fa',
  path: '/setup-2fa',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInviteRoute = AcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTransacoesRoute = AdminTransacoesRouteImport.update({
  id: '/transacoes',
  path: '/transacoes',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSorteiosRoute = AdminSorteiosRouteImport.update({
  id: '/sorteios',
  path: '/sorteios',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSeoRoute = AdminSeoRouteImport.update({
  id: '/seo',
  path: '/seo',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSaudeSistemaRoute = AdminSaudeSistemaRouteImport.update({
  id: '/saude-sistema',
  path: '/saude-sistema',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSaquesRoute = AdminSaquesRouteImport.update({
  id: '/saques',
  path: '/saques',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRelatoriosRoute = AdminRelatoriosRouteImport.update({
  id: '/relatorios',
  path: '/relatorios',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPremiosRoute = AdminPremiosRouteImport.update({
  id: '/premios',
  path: '/premios',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMeuPerfilRoute = AdminMeuPerfilRouteImport.update({
  id: '/meu-perfil',
  path: '/meu-perfil',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLogsRoute = AdminLogsRouteImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLeadsRoute = AdminLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => AdminRoute,
} as any)
const AdminKycRoute = AdminKycRouteImport.update({
  id: '/kyc',
  path: '/kyc',
  getParentRoute: () => AdminRoute,
} as any)
const AdminIpSecurityRoute = AdminIpSecurityRouteImport.update({
  id: '/ip-security',
  path: '/ip-security',
  getParentRoute: () => AdminRoute,
} as any)
const AdminIntegracoesRoute = AdminIntegracoesRouteImport.update({
  id: '/integracoes',
  path: '/integracoes',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFunilRoute = AdminFunilRouteImport.update({
  id: '/funil',
  path: '/funil',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFaturamentoRoute = AdminFaturamentoRouteImport.update({
  id: '/faturamento',
  path: '/faturamento',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEquipeRoute = AdminEquipeRouteImport.update({
  id: '/equipe',
  path: '/equipe',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEnviosRoute = AdminEnviosRouteImport.update({
  id: '/envios',
  path: '/envios',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDestaquesRoute = AdminDestaquesRouteImport.update({
  id: '/destaques',
  path: '/destaques',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDashboardRoute = AdminDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AdminRoute,
} as any)
const AdminConfiguracoesRoute = AdminConfiguracoesRouteImport.update({
  id: '/configuracoes',
  path: '/configuracoes',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCircuitBreakersRoute = AdminCircuitBreakersRouteImport.update({
  id: '/circuit-breakers',
  path: '/circuit-breakers',
  getParentRoute: () => AdminRoute,
} as any)
const AdminChangePasswordRoute = AdminChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCampanhasRoute = AdminCampanhasRouteImport.update({
  id: '/campanhas',
  path: '/campanhas',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBtagsRoute = AdminBtagsRouteImport.update({
  id: '/btags',
  path: '/btags',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBannersRoute = AdminBannersRouteImport.update({
  id: '/banners',
  path: '/banners',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAuditoriaRoute = AdminAuditoriaRouteImport.update({
  id: '/auditoria',
  path: '/auditoria',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAlertasRoute = AdminAlertasRouteImport.update({
  id: '/alertas',
  path: '/alertas',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAfiliadosRoute = AdminAfiliadosRouteImport.update({
  id: '/afiliados',
  path: '/afiliados',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsuariosIndexRoute = AdminUsuariosIndexRouteImport.update({
  id: '/usuarios/',
  path: '/usuarios/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTemasIndexRoute = AdminTemasIndexRouteImport.update({
  id: '/temas/',
  path: '/temas/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSeoIndexRoute = AdminSeoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminSeoRoute,
} as any)
const AdminMediaIndexRoute = AdminMediaIndexRouteImport.update({
  id: '/media/',
  path: '/media/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminJogosIndexRoute = AdminJogosIndexRouteImport.update({
  id: '/jogos/',
  path: '/jogos/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAlertasSegurancaIndexRoute =
  AdminAlertasSegurancaIndexRouteImport.update({
    id: '/alertas-seguranca/',
    path: '/alertas-seguranca/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminUsuariosIdRoute = AdminUsuariosIdRouteImport.update({
  id: '/usuarios/$id',
  path: '/usuarios/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSorteiosPendentesRoute = AdminSorteiosPendentesRouteImport.update({
  id: '/pendentes',
  path: '/pendentes',
  getParentRoute: () => AdminSorteiosRoute,
} as any)
const AdminSorteiosEncerradosRoute = AdminSorteiosEncerradosRouteImport.update({
  id: '/encerrados',
  path: '/encerrados',
  getParentRoute: () => AdminSorteiosRoute,
} as any)
const AdminSeoSlugRoute = AdminSeoSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => AdminSeoRoute,
} as any)
const AdminSegurancaSessoesRoute = AdminSegurancaSessoesRouteImport.update({
  id: '/seguranca/sessoes',
  path: '/seguranca/sessoes',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSegurancaIpAllowlistRoute =
  AdminSegurancaIpAllowlistRouteImport.update({
    id: '/seguranca/ip-allowlist',
    path: '/seguranca/ip-allowlist',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminSaquesManualReviewRoute = AdminSaquesManualReviewRouteImport.update({
  id: '/manual-review',
  path: '/manual-review',
  getParentRoute: () => AdminSaquesRoute,
} as any)
const AdminSaquesHistoricoRoute = AdminSaquesHistoricoRouteImport.update({
  id: '/historico',
  path: '/historico',
  getParentRoute: () => AdminSaquesRoute,
} as any)
const AdminPresentationArchitectureRoute =
  AdminPresentationArchitectureRouteImport.update({
    id: '/presentation/architecture',
    path: '/presentation/architecture',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminMediaPastasRoute = AdminMediaPastasRouteImport.update({
  id: '/media/pastas',
  path: '/media/pastas',
  getParentRoute: () => AdminRoute,
} as any)
const AdminJogosTemplatesRoute = AdminJogosTemplatesRouteImport.update({
  id: '/jogos/templates',
  path: '/jogos/templates',
  getParentRoute: () => AdminRoute,
} as any)
const AdminJogosNewRoute = AdminJogosNewRouteImport.update({
  id: '/jogos/new',
  path: '/jogos/new',
  getParentRoute: () => AdminRoute,
} as any)
const AdminJogosModalidadesRoute = AdminJogosModalidadesRouteImport.update({
  id: '/jogos/modalidades',
  path: '/jogos/modalidades',
  getParentRoute: () => AdminRoute,
} as any)
const AdminJogosEncerradosRoute = AdminJogosEncerradosRouteImport.update({
  id: '/jogos/encerrados',
  path: '/jogos/encerrados',
  getParentRoute: () => AdminRoute,
} as any)
const AdminJogosCadastradosRoute = AdminJogosCadastradosRouteImport.update({
  id: '/jogos/cadastrados',
  path: '/jogos/cadastrados',
  getParentRoute: () => AdminRoute,
} as any)
const AdminJogosAndamentoRoute = AdminJogosAndamentoRouteImport.update({
  id: '/jogos/andamento',
  path: '/jogos/andamento',
  getParentRoute: () => AdminRoute,
} as any)
const AdminJogosIdRoute = AdminJogosIdRouteImport.update({
  id: '/jogos/$id',
  path: '/jogos/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDocsTokensRoute = AdminDocsTokensRouteImport.update({
  id: '/docs/tokens',
  path: '/docs/tokens',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDocsTemplatesRoute = AdminDocsTemplatesRouteImport.update({
  id: '/docs/templates',
  path: '/docs/templates',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDocsSegurancaRoute = AdminDocsSegurancaRouteImport.update({
  id: '/docs/seguranca',
  path: '/docs/seguranca',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDocsJogosRoute = AdminDocsJogosRouteImport.update({
  id: '/docs/jogos',
  path: '/docs/jogos',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDocsAuthRoute = AdminDocsAuthRouteImport.update({
  id: '/docs/auth',
  path: '/docs/auth',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDocsApiIntegracaoRoute = AdminDocsApiIntegracaoRouteImport.update({
  id: '/docs/api-integracao',
  path: '/docs/api-integracao',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAlertasEntregasRoute = AdminAlertasEntregasRouteImport.update({
  id: '/entregas',
  path: '/entregas',
  getParentRoute: () => AdminAlertasRoute,
} as any)
const AdminAlertasSegurancaPreferenciasRoute =
  AdminAlertasSegurancaPreferenciasRouteImport.update({
    id: '/alertas-seguranca/preferencias',
    path: '/alertas-seguranca/preferencias',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminAlertasSegurancaIdRoute = AdminAlertasSegurancaIdRouteImport.update({
  id: '/alertas-seguranca/$id',
  path: '/alertas-seguranca/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLotepEstruturasIndexRoute =
  AdminLotepEstruturasIndexRouteImport.update({
    id: '/lotep/estruturas/',
    path: '/lotep/estruturas/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminKycReviewIndexRoute = AdminKycReviewIndexRouteImport.update({
  id: '/review/',
  path: '/review/',
  getParentRoute: () => AdminKycRoute,
} as any)
const AdminTemasPreviewCodeRoute = AdminTemasPreviewCodeRouteImport.update({
  id: '/temas/preview/$code',
  path: '/temas/preview/$code',
  getParentRoute: () => AdminRoute,
} as any)
const AdminKycReviewIdRoute = AdminKycReviewIdRouteImport.update({
  id: '/review/$id',
  path: '/review/$id',
  getParentRoute: () => AdminKycRoute,
} as any)
const AdminJogosIdDashboardRoute = AdminJogosIdDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AdminJogosIdRoute,
} as any)
const AdminLotepEstruturasStructureIdPoolRoute =
  AdminLotepEstruturasStructureIdPoolRouteImport.update({
    id: '/lotep/estruturas/$structureId/pool',
    path: '/lotep/estruturas/$structureId/pool',
    getParentRoute: () => AdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/setup-2fa': typeof Setup2faRoute
  '/verify-2fa': typeof Verify2faRoute
  '/afiliados': typeof AdminAfiliadosRoute
  '/alertas': typeof AdminAlertasRouteWithChildren
  '/auditoria': typeof AdminAuditoriaRoute
  '/banners': typeof AdminBannersRoute
  '/btags': typeof AdminBtagsRoute
  '/campanhas': typeof AdminCampanhasRoute
  '/change-password': typeof AdminChangePasswordRoute
  '/circuit-breakers': typeof AdminCircuitBreakersRoute
  '/configuracoes': typeof AdminConfiguracoesRoute
  '/dashboard': typeof AdminDashboardRoute
  '/destaques': typeof AdminDestaquesRoute
  '/envios': typeof AdminEnviosRoute
  '/equipe': typeof AdminEquipeRoute
  '/faturamento': typeof AdminFaturamentoRoute
  '/funil': typeof AdminFunilRoute
  '/integracoes': typeof AdminIntegracoesRoute
  '/ip-security': typeof AdminIpSecurityRoute
  '/kyc': typeof AdminKycRouteWithChildren
  '/leads': typeof AdminLeadsRoute
  '/logs': typeof AdminLogsRoute
  '/meu-perfil': typeof AdminMeuPerfilRoute
  '/premios': typeof AdminPremiosRoute
  '/relatorios': typeof AdminRelatoriosRoute
  '/saques': typeof AdminSaquesRouteWithChildren
  '/saude-sistema': typeof AdminSaudeSistemaRoute
  '/seo': typeof AdminSeoRouteWithChildren
  '/sorteios': typeof AdminSorteiosRouteWithChildren
  '/transacoes': typeof AdminTransacoesRoute
  '/alertas-seguranca/$id': typeof AdminAlertasSegurancaIdRoute
  '/alertas-seguranca/preferencias': typeof AdminAlertasSegurancaPreferenciasRoute
  '/alertas/entregas': typeof AdminAlertasEntregasRoute
  '/docs/api-integracao': typeof AdminDocsApiIntegracaoRoute
  '/docs/auth': typeof AdminDocsAuthRoute
  '/docs/jogos': typeof AdminDocsJogosRoute
  '/docs/seguranca': typeof AdminDocsSegurancaRoute
  '/docs/templates': typeof AdminDocsTemplatesRoute
  '/docs/tokens': typeof AdminDocsTokensRoute
  '/jogos/$id': typeof AdminJogosIdRouteWithChildren
  '/jogos/andamento': typeof AdminJogosAndamentoRoute
  '/jogos/cadastrados': typeof AdminJogosCadastradosRoute
  '/jogos/encerrados': typeof AdminJogosEncerradosRoute
  '/jogos/modalidades': typeof AdminJogosModalidadesRoute
  '/jogos/new': typeof AdminJogosNewRoute
  '/jogos/templates': typeof AdminJogosTemplatesRoute
  '/media/pastas': typeof AdminMediaPastasRoute
  '/presentation/architecture': typeof AdminPresentationArchitectureRoute
  '/saques/historico': typeof AdminSaquesHistoricoRoute
  '/saques/manual-review': typeof AdminSaquesManualReviewRoute
  '/seguranca/ip-allowlist': typeof AdminSegurancaIpAllowlistRoute
  '/seguranca/sessoes': typeof AdminSegurancaSessoesRoute
  '/seo/$slug': typeof AdminSeoSlugRoute
  '/sorteios/encerrados': typeof AdminSorteiosEncerradosRoute
  '/sorteios/pendentes': typeof AdminSorteiosPendentesRoute
  '/usuarios/$id': typeof AdminUsuariosIdRoute
  '/alertas-seguranca/': typeof AdminAlertasSegurancaIndexRoute
  '/jogos/': typeof AdminJogosIndexRoute
  '/media/': typeof AdminMediaIndexRoute
  '/seo/': typeof AdminSeoIndexRoute
  '/temas/': typeof AdminTemasIndexRoute
  '/usuarios/': typeof AdminUsuariosIndexRoute
  '/jogos/$id/dashboard': typeof AdminJogosIdDashboardRoute
  '/kyc/review/$id': typeof AdminKycReviewIdRoute
  '/temas/preview/$code': typeof AdminTemasPreviewCodeRoute
  '/kyc/review/': typeof AdminKycReviewIndexRoute
  '/lotep/estruturas/': typeof AdminLotepEstruturasIndexRoute
  '/lotep/estruturas/$structureId/pool': typeof AdminLotepEstruturasStructureIdPoolRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/setup-2fa': typeof Setup2faRoute
  '/verify-2fa': typeof Verify2faRoute
  '/afiliados': typeof AdminAfiliadosRoute
  '/alertas': typeof AdminAlertasRouteWithChildren
  '/auditoria': typeof AdminAuditoriaRoute
  '/banners': typeof AdminBannersRoute
  '/btags': typeof AdminBtagsRoute
  '/campanhas': typeof AdminCampanhasRoute
  '/change-password': typeof AdminChangePasswordRoute
  '/circuit-breakers': typeof AdminCircuitBreakersRoute
  '/configuracoes': typeof AdminConfiguracoesRoute
  '/dashboard': typeof AdminDashboardRoute
  '/destaques': typeof AdminDestaquesRoute
  '/envios': typeof AdminEnviosRoute
  '/equipe': typeof AdminEquipeRoute
  '/faturamento': typeof AdminFaturamentoRoute
  '/funil': typeof AdminFunilRoute
  '/integracoes': typeof AdminIntegracoesRoute
  '/ip-security': typeof AdminIpSecurityRoute
  '/kyc': typeof AdminKycRouteWithChildren
  '/leads': typeof AdminLeadsRoute
  '/logs': typeof AdminLogsRoute
  '/meu-perfil': typeof AdminMeuPerfilRoute
  '/premios': typeof AdminPremiosRoute
  '/relatorios': typeof AdminRelatoriosRoute
  '/saques': typeof AdminSaquesRouteWithChildren
  '/saude-sistema': typeof AdminSaudeSistemaRoute
  '/sorteios': typeof AdminSorteiosRouteWithChildren
  '/transacoes': typeof AdminTransacoesRoute
  '/alertas-seguranca/$id': typeof AdminAlertasSegurancaIdRoute
  '/alertas-seguranca/preferencias': typeof AdminAlertasSegurancaPreferenciasRoute
  '/alertas/entregas': typeof AdminAlertasEntregasRoute
  '/docs/api-integracao': typeof AdminDocsApiIntegracaoRoute
  '/docs/auth': typeof AdminDocsAuthRoute
  '/docs/jogos': typeof AdminDocsJogosRoute
  '/docs/seguranca': typeof AdminDocsSegurancaRoute
  '/docs/templates': typeof AdminDocsTemplatesRoute
  '/docs/tokens': typeof AdminDocsTokensRoute
  '/jogos/$id': typeof AdminJogosIdRouteWithChildren
  '/jogos/andamento': typeof AdminJogosAndamentoRoute
  '/jogos/cadastrados': typeof AdminJogosCadastradosRoute
  '/jogos/encerrados': typeof AdminJogosEncerradosRoute
  '/jogos/modalidades': typeof AdminJogosModalidadesRoute
  '/jogos/new': typeof AdminJogosNewRoute
  '/jogos/templates': typeof AdminJogosTemplatesRoute
  '/media/pastas': typeof AdminMediaPastasRoute
  '/presentation/architecture': typeof AdminPresentationArchitectureRoute
  '/saques/historico': typeof AdminSaquesHistoricoRoute
  '/saques/manual-review': typeof AdminSaquesManualReviewRoute
  '/seguranca/ip-allowlist': typeof AdminSegurancaIpAllowlistRoute
  '/seguranca/sessoes': typeof AdminSegurancaSessoesRoute
  '/seo/$slug': typeof AdminSeoSlugRoute
  '/sorteios/encerrados': typeof AdminSorteiosEncerradosRoute
  '/sorteios/pendentes': typeof AdminSorteiosPendentesRoute
  '/usuarios/$id': typeof AdminUsuariosIdRoute
  '/alertas-seguranca': typeof AdminAlertasSegurancaIndexRoute
  '/jogos': typeof AdminJogosIndexRoute
  '/media': typeof AdminMediaIndexRoute
  '/seo': typeof AdminSeoIndexRoute
  '/temas': typeof AdminTemasIndexRoute
  '/usuarios': typeof AdminUsuariosIndexRoute
  '/jogos/$id/dashboard': typeof AdminJogosIdDashboardRoute
  '/kyc/review/$id': typeof AdminKycReviewIdRoute
  '/temas/preview/$code': typeof AdminTemasPreviewCodeRoute
  '/kyc/review': typeof AdminKycReviewIndexRoute
  '/lotep/estruturas': typeof AdminLotepEstruturasIndexRoute
  '/lotep/estruturas/$structureId/pool': typeof AdminLotepEstruturasStructureIdPoolRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_admin': typeof AdminRouteWithChildren
  '/accept-invite': typeof AcceptInviteRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/setup-2fa': typeof Setup2faRoute
  '/verify-2fa': typeof Verify2faRoute
  '/_admin/afiliados': typeof AdminAfiliadosRoute
  '/_admin/alertas': typeof AdminAlertasRouteWithChildren
  '/_admin/auditoria': typeof AdminAuditoriaRoute
  '/_admin/banners': typeof AdminBannersRoute
  '/_admin/btags': typeof AdminBtagsRoute
  '/_admin/campanhas': typeof AdminCampanhasRoute
  '/_admin/change-password': typeof AdminChangePasswordRoute
  '/_admin/circuit-breakers': typeof AdminCircuitBreakersRoute
  '/_admin/configuracoes': typeof AdminConfiguracoesRoute
  '/_admin/dashboard': typeof AdminDashboardRoute
  '/_admin/destaques': typeof AdminDestaquesRoute
  '/_admin/envios': typeof AdminEnviosRoute
  '/_admin/equipe': typeof AdminEquipeRoute
  '/_admin/faturamento': typeof AdminFaturamentoRoute
  '/_admin/funil': typeof AdminFunilRoute
  '/_admin/integracoes': typeof AdminIntegracoesRoute
  '/_admin/ip-security': typeof AdminIpSecurityRoute
  '/_admin/kyc': typeof AdminKycRouteWithChildren
  '/_admin/leads': typeof AdminLeadsRoute
  '/_admin/logs': typeof AdminLogsRoute
  '/_admin/meu-perfil': typeof AdminMeuPerfilRoute
  '/_admin/premios': typeof AdminPremiosRoute
  '/_admin/relatorios': typeof AdminRelatoriosRoute
  '/_admin/saques': typeof AdminSaquesRouteWithChildren
  '/_admin/saude-sistema': typeof AdminSaudeSistemaRoute
  '/_admin/seo': typeof AdminSeoRouteWithChildren
  '/_admin/sorteios': typeof AdminSorteiosRouteWithChildren
  '/_admin/transacoes': typeof AdminTransacoesRoute
  '/_admin/alertas-seguranca/$id': typeof AdminAlertasSegurancaIdRoute
  '/_admin/alertas-seguranca/preferencias': typeof AdminAlertasSegurancaPreferenciasRoute
  '/_admin/alertas/entregas': typeof AdminAlertasEntregasRoute
  '/_admin/docs/api-integracao': typeof AdminDocsApiIntegracaoRoute
  '/_admin/docs/auth': typeof AdminDocsAuthRoute
  '/_admin/docs/jogos': typeof AdminDocsJogosRoute
  '/_admin/docs/seguranca': typeof AdminDocsSegurancaRoute
  '/_admin/docs/templates': typeof AdminDocsTemplatesRoute
  '/_admin/docs/tokens': typeof AdminDocsTokensRoute
  '/_admin/jogos/$id': typeof AdminJogosIdRouteWithChildren
  '/_admin/jogos/andamento': typeof AdminJogosAndamentoRoute
  '/_admin/jogos/cadastrados': typeof AdminJogosCadastradosRoute
  '/_admin/jogos/encerrados': typeof AdminJogosEncerradosRoute
  '/_admin/jogos/modalidades': typeof AdminJogosModalidadesRoute
  '/_admin/jogos/new': typeof AdminJogosNewRoute
  '/_admin/jogos/templates': typeof AdminJogosTemplatesRoute
  '/_admin/media/pastas': typeof AdminMediaPastasRoute
  '/_admin/presentation/architecture': typeof AdminPresentationArchitectureRoute
  '/_admin/saques/historico': typeof AdminSaquesHistoricoRoute
  '/_admin/saques/manual-review': typeof AdminSaquesManualReviewRoute
  '/_admin/seguranca/ip-allowlist': typeof AdminSegurancaIpAllowlistRoute
  '/_admin/seguranca/sessoes': typeof AdminSegurancaSessoesRoute
  '/_admin/seo/$slug': typeof AdminSeoSlugRoute
  '/_admin/sorteios/encerrados': typeof AdminSorteiosEncerradosRoute
  '/_admin/sorteios/pendentes': typeof AdminSorteiosPendentesRoute
  '/_admin/usuarios/$id': typeof AdminUsuariosIdRoute
  '/_admin/alertas-seguranca/': typeof AdminAlertasSegurancaIndexRoute
  '/_admin/jogos/': typeof AdminJogosIndexRoute
  '/_admin/media/': typeof AdminMediaIndexRoute
  '/_admin/seo/': typeof AdminSeoIndexRoute
  '/_admin/temas/': typeof AdminTemasIndexRoute
  '/_admin/usuarios/': typeof AdminUsuariosIndexRoute
  '/_admin/jogos/$id/dashboard': typeof AdminJogosIdDashboardRoute
  '/_admin/kyc/review/$id': typeof AdminKycReviewIdRoute
  '/_admin/temas/preview/$code': typeof AdminTemasPreviewCodeRoute
  '/_admin/kyc/review/': typeof AdminKycReviewIndexRoute
  '/_admin/lotep/estruturas/': typeof AdminLotepEstruturasIndexRoute
  '/_admin/lotep/estruturas/$structureId/pool': typeof AdminLotepEstruturasStructureIdPoolRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invite'
    | '/forgot-password'
    | '/login'
    | '/setup-2fa'
    | '/verify-2fa'
    | '/afiliados'
    | '/alertas'
    | '/auditoria'
    | '/banners'
    | '/btags'
    | '/campanhas'
    | '/change-password'
    | '/circuit-breakers'
    | '/configuracoes'
    | '/dashboard'
    | '/destaques'
    | '/envios'
    | '/equipe'
    | '/faturamento'
    | '/funil'
    | '/integracoes'
    | '/ip-security'
    | '/kyc'
    | '/leads'
    | '/logs'
    | '/meu-perfil'
    | '/premios'
    | '/relatorios'
    | '/saques'
    | '/saude-sistema'
    | '/seo'
    | '/sorteios'
    | '/transacoes'
    | '/alertas-seguranca/$id'
    | '/alertas-seguranca/preferencias'
    | '/alertas/entregas'
    | '/docs/api-integracao'
    | '/docs/auth'
    | '/docs/jogos'
    | '/docs/seguranca'
    | '/docs/templates'
    | '/docs/tokens'
    | '/jogos/$id'
    | '/jogos/andamento'
    | '/jogos/cadastrados'
    | '/jogos/encerrados'
    | '/jogos/modalidades'
    | '/jogos/new'
    | '/jogos/templates'
    | '/media/pastas'
    | '/presentation/architecture'
    | '/saques/historico'
    | '/saques/manual-review'
    | '/seguranca/ip-allowlist'
    | '/seguranca/sessoes'
    | '/seo/$slug'
    | '/sorteios/encerrados'
    | '/sorteios/pendentes'
    | '/usuarios/$id'
    | '/alertas-seguranca/'
    | '/jogos/'
    | '/media/'
    | '/seo/'
    | '/temas/'
    | '/usuarios/'
    | '/jogos/$id/dashboard'
    | '/kyc/review/$id'
    | '/temas/preview/$code'
    | '/kyc/review/'
    | '/lotep/estruturas/'
    | '/lotep/estruturas/$structureId/pool'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accept-invite'
    | '/forgot-password'
    | '/login'
    | '/setup-2fa'
    | '/verify-2fa'
    | '/afiliados'
    | '/alertas'
    | '/auditoria'
    | '/banners'
    | '/btags'
    | '/campanhas'
    | '/change-password'
    | '/circuit-breakers'
    | '/configuracoes'
    | '/dashboard'
    | '/destaques'
    | '/envios'
    | '/equipe'
    | '/faturamento'
    | '/funil'
    | '/integracoes'
    | '/ip-security'
    | '/kyc'
    | '/leads'
    | '/logs'
    | '/meu-perfil'
    | '/premios'
    | '/relatorios'
    | '/saques'
    | '/saude-sistema'
    | '/sorteios'
    | '/transacoes'
    | '/alertas-seguranca/$id'
    | '/alertas-seguranca/preferencias'
    | '/alertas/entregas'
    | '/docs/api-integracao'
    | '/docs/auth'
    | '/docs/jogos'
    | '/docs/seguranca'
    | '/docs/templates'
    | '/docs/tokens'
    | '/jogos/$id'
    | '/jogos/andamento'
    | '/jogos/cadastrados'
    | '/jogos/encerrados'
    | '/jogos/modalidades'
    | '/jogos/new'
    | '/jogos/templates'
    | '/media/pastas'
    | '/presentation/architecture'
    | '/saques/historico'
    | '/saques/manual-review'
    | '/seguranca/ip-allowlist'
    | '/seguranca/sessoes'
    | '/seo/$slug'
    | '/sorteios/encerrados'
    | '/sorteios/pendentes'
    | '/usuarios/$id'
    | '/alertas-seguranca'
    | '/jogos'
    | '/media'
    | '/seo'
    | '/temas'
    | '/usuarios'
    | '/jogos/$id/dashboard'
    | '/kyc/review/$id'
    | '/temas/preview/$code'
    | '/kyc/review'
    | '/lotep/estruturas'
    | '/lotep/estruturas/$structureId/pool'
  id:
    | '__root__'
    | '/'
    | '/_admin'
    | '/accept-invite'
    | '/forgot-password'
    | '/login'
    | '/setup-2fa'
    | '/verify-2fa'
    | '/_admin/afiliados'
    | '/_admin/alertas'
    | '/_admin/auditoria'
    | '/_admin/banners'
    | '/_admin/btags'
    | '/_admin/campanhas'
    | '/_admin/change-password'
    | '/_admin/circuit-breakers'
    | '/_admin/configuracoes'
    | '/_admin/dashboard'
    | '/_admin/destaques'
    | '/_admin/envios'
    | '/_admin/equipe'
    | '/_admin/faturamento'
    | '/_admin/funil'
    | '/_admin/integracoes'
    | '/_admin/ip-security'
    | '/_admin/kyc'
    | '/_admin/leads'
    | '/_admin/logs'
    | '/_admin/meu-perfil'
    | '/_admin/premios'
    | '/_admin/relatorios'
    | '/_admin/saques'
    | '/_admin/saude-sistema'
    | '/_admin/seo'
    | '/_admin/sorteios'
    | '/_admin/transacoes'
    | '/_admin/alertas-seguranca/$id'
    | '/_admin/alertas-seguranca/preferencias'
    | '/_admin/alertas/entregas'
    | '/_admin/docs/api-integracao'
    | '/_admin/docs/auth'
    | '/_admin/docs/jogos'
    | '/_admin/docs/seguranca'
    | '/_admin/docs/templates'
    | '/_admin/docs/tokens'
    | '/_admin/jogos/$id'
    | '/_admin/jogos/andamento'
    | '/_admin/jogos/cadastrados'
    | '/_admin/jogos/encerrados'
    | '/_admin/jogos/modalidades'
    | '/_admin/jogos/new'
    | '/_admin/jogos/templates'
    | '/_admin/media/pastas'
    | '/_admin/presentation/architecture'
    | '/_admin/saques/historico'
    | '/_admin/saques/manual-review'
    | '/_admin/seguranca/ip-allowlist'
    | '/_admin/seguranca/sessoes'
    | '/_admin/seo/$slug'
    | '/_admin/sorteios/encerrados'
    | '/_admin/sorteios/pendentes'
    | '/_admin/usuarios/$id'
    | '/_admin/alertas-seguranca/'
    | '/_admin/jogos/'
    | '/_admin/media/'
    | '/_admin/seo/'
    | '/_admin/temas/'
    | '/_admin/usuarios/'
    | '/_admin/jogos/$id/dashboard'
    | '/_admin/kyc/review/$id'
    | '/_admin/temas/preview/$code'
    | '/_admin/kyc/review/'
    | '/_admin/lotep/estruturas/'
    | '/_admin/lotep/estruturas/$structureId/pool'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  AcceptInviteRoute: typeof AcceptInviteRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  Setup2faRoute: typeof Setup2faRoute
  Verify2faRoute: typeof Verify2faRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-2fa': {
      id: '/verify-2fa'
      path: '/verify-2fa'
      fullPath: '/verify-2fa'
      preLoaderRoute: typeof Verify2faRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup-2fa': {
      id: '/setup-2fa'
      path: '/setup-2fa'
      fullPath: '/setup-2fa'
      preLoaderRoute: typeof Setup2faRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invite': {
      id: '/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin': {
      id: '/_admin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin/transacoes': {
      id: '/_admin/transacoes'
      path: '/transacoes'
      fullPath: '/transacoes'
      preLoaderRoute: typeof AdminTransacoesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/sorteios': {
      id: '/_admin/sorteios'
      path: '/sorteios'
      fullPath: '/sorteios'
      preLoaderRoute: typeof AdminSorteiosRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/seo': {
      id: '/_admin/seo'
      path: '/seo'
      fullPath: '/seo'
      preLoaderRoute: typeof AdminSeoRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/saude-sistema': {
      id: '/_admin/saude-sistema'
      path: '/saude-sistema'
      fullPath: '/saude-sistema'
      preLoaderRoute: typeof AdminSaudeSistemaRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/saques': {
      id: '/_admin/saques'
      path: '/saques'
      fullPath: '/saques'
      preLoaderRoute: typeof AdminSaquesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/relatorios': {
      id: '/_admin/relatorios'
      path: '/relatorios'
      fullPath: '/relatorios'
      preLoaderRoute: typeof AdminRelatoriosRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/premios': {
      id: '/_admin/premios'
      path: '/premios'
      fullPath: '/premios'
      preLoaderRoute: typeof AdminPremiosRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/meu-perfil': {
      id: '/_admin/meu-perfil'
      path: '/meu-perfil'
      fullPath: '/meu-perfil'
      preLoaderRoute: typeof AdminMeuPerfilRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/logs': {
      id: '/_admin/logs'
      path: '/logs'
      fullPath: '/logs'
      preLoaderRoute: typeof AdminLogsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/leads': {
      id: '/_admin/leads'
      path: '/leads'
      fullPath: '/leads'
      preLoaderRoute: typeof AdminLeadsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/kyc': {
      id: '/_admin/kyc'
      path: '/kyc'
      fullPath: '/kyc'
      preLoaderRoute: typeof AdminKycRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/ip-security': {
      id: '/_admin/ip-security'
      path: '/ip-security'
      fullPath: '/ip-security'
      preLoaderRoute: typeof AdminIpSecurityRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/integracoes': {
      id: '/_admin/integracoes'
      path: '/integracoes'
      fullPath: '/integracoes'
      preLoaderRoute: typeof AdminIntegracoesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/funil': {
      id: '/_admin/funil'
      path: '/funil'
      fullPath: '/funil'
      preLoaderRoute: typeof AdminFunilRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/faturamento': {
      id: '/_admin/faturamento'
      path: '/faturamento'
      fullPath: '/faturamento'
      preLoaderRoute: typeof AdminFaturamentoRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/equipe': {
      id: '/_admin/equipe'
      path: '/equipe'
      fullPath: '/equipe'
      preLoaderRoute: typeof AdminEquipeRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/envios': {
      id: '/_admin/envios'
      path: '/envios'
      fullPath: '/envios'
      preLoaderRoute: typeof AdminEnviosRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/destaques': {
      id: '/_admin/destaques'
      path: '/destaques'
      fullPath: '/destaques'
      preLoaderRoute: typeof AdminDestaquesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/dashboard': {
      id: '/_admin/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AdminDashboardRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/configuracoes': {
      id: '/_admin/configuracoes'
      path: '/configuracoes'
      fullPath: '/configuracoes'
      preLoaderRoute: typeof AdminConfiguracoesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/circuit-breakers': {
      id: '/_admin/circuit-breakers'
      path: '/circuit-breakers'
      fullPath: '/circuit-breakers'
      preLoaderRoute: typeof AdminCircuitBreakersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/change-password': {
      id: '/_admin/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof AdminChangePasswordRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/campanhas': {
      id: '/_admin/campanhas'
      path: '/campanhas'
      fullPath: '/campanhas'
      preLoaderRoute: typeof AdminCampanhasRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/btags': {
      id: '/_admin/btags'
      path: '/btags'
      fullPath: '/btags'
      preLoaderRoute: typeof AdminBtagsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/banners': {
      id: '/_admin/banners'
      path: '/banners'
      fullPath: '/banners'
      preLoaderRoute: typeof AdminBannersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/auditoria': {
      id: '/_admin/auditoria'
      path: '/auditoria'
      fullPath: '/auditoria'
      preLoaderRoute: typeof AdminAuditoriaRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/alertas': {
      id: '/_admin/alertas'
      path: '/alertas'
      fullPath: '/alertas'
      preLoaderRoute: typeof AdminAlertasRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/afiliados': {
      id: '/_admin/afiliados'
      path: '/afiliados'
      fullPath: '/afiliados'
      preLoaderRoute: typeof AdminAfiliadosRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/usuarios/': {
      id: '/_admin/usuarios/'
      path: '/usuarios'
      fullPath: '/usuarios/'
      preLoaderRoute: typeof AdminUsuariosIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/temas/': {
      id: '/_admin/temas/'
      path: '/temas'
      fullPath: '/temas/'
      preLoaderRoute: typeof AdminTemasIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/seo/': {
      id: '/_admin/seo/'
      path: '/'
      fullPath: '/seo/'
      preLoaderRoute: typeof AdminSeoIndexRouteImport
      parentRoute: typeof AdminSeoRoute
    }
    '/_admin/media/': {
      id: '/_admin/media/'
      path: '/media'
      fullPath: '/media/'
      preLoaderRoute: typeof AdminMediaIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/jogos/': {
      id: '/_admin/jogos/'
      path: '/jogos'
      fullPath: '/jogos/'
      preLoaderRoute: typeof AdminJogosIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/alertas-seguranca/': {
      id: '/_admin/alertas-seguranca/'
      path: '/alertas-seguranca'
      fullPath: '/alertas-seguranca/'
      preLoaderRoute: typeof AdminAlertasSegurancaIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/usuarios/$id': {
      id: '/_admin/usuarios/$id'
      path: '/usuarios/$id'
      fullPath: '/usuarios/$id'
      preLoaderRoute: typeof AdminUsuariosIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/sorteios/pendentes': {
      id: '/_admin/sorteios/pendentes'
      path: '/pendentes'
      fullPath: '/sorteios/pendentes'
      preLoaderRoute: typeof AdminSorteiosPendentesRouteImport
      parentRoute: typeof AdminSorteiosRoute
    }
    '/_admin/sorteios/encerrados': {
      id: '/_admin/sorteios/encerrados'
      path: '/encerrados'
      fullPath: '/sorteios/encerrados'
      preLoaderRoute: typeof AdminSorteiosEncerradosRouteImport
      parentRoute: typeof AdminSorteiosRoute
    }
    '/_admin/seo/$slug': {
      id: '/_admin/seo/$slug'
      path: '/$slug'
      fullPath: '/seo/$slug'
      preLoaderRoute: typeof AdminSeoSlugRouteImport
      parentRoute: typeof AdminSeoRoute
    }
    '/_admin/seguranca/sessoes': {
      id: '/_admin/seguranca/sessoes'
      path: '/seguranca/sessoes'
      fullPath: '/seguranca/sessoes'
      preLoaderRoute: typeof AdminSegurancaSessoesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/seguranca/ip-allowlist': {
      id: '/_admin/seguranca/ip-allowlist'
      path: '/seguranca/ip-allowlist'
      fullPath: '/seguranca/ip-allowlist'
      preLoaderRoute: typeof AdminSegurancaIpAllowlistRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/saques/manual-review': {
      id: '/_admin/saques/manual-review'
      path: '/manual-review'
      fullPath: '/saques/manual-review'
      preLoaderRoute: typeof AdminSaquesManualReviewRouteImport
      parentRoute: typeof AdminSaquesRoute
    }
    '/_admin/saques/historico': {
      id: '/_admin/saques/historico'
      path: '/historico'
      fullPath: '/saques/historico'
      preLoaderRoute: typeof AdminSaquesHistoricoRouteImport
      parentRoute: typeof AdminSaquesRoute
    }
    '/_admin/presentation/architecture': {
      id: '/_admin/presentation/architecture'
      path: '/presentation/architecture'
      fullPath: '/presentation/architecture'
      preLoaderRoute: typeof AdminPresentationArchitectureRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/media/pastas': {
      id: '/_admin/media/pastas'
      path: '/media/pastas'
      fullPath: '/media/pastas'
      preLoaderRoute: typeof AdminMediaPastasRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/jogos/templates': {
      id: '/_admin/jogos/templates'
      path: '/jogos/templates'
      fullPath: '/jogos/templates'
      preLoaderRoute: typeof AdminJogosTemplatesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/jogos/new': {
      id: '/_admin/jogos/new'
      path: '/jogos/new'
      fullPath: '/jogos/new'
      preLoaderRoute: typeof AdminJogosNewRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/jogos/modalidades': {
      id: '/_admin/jogos/modalidades'
      path: '/jogos/modalidades'
      fullPath: '/jogos/modalidades'
      preLoaderRoute: typeof AdminJogosModalidadesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/jogos/encerrados': {
      id: '/_admin/jogos/encerrados'
      path: '/jogos/encerrados'
      fullPath: '/jogos/encerrados'
      preLoaderRoute: typeof AdminJogosEncerradosRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/jogos/cadastrados': {
      id: '/_admin/jogos/cadastrados'
      path: '/jogos/cadastrados'
      fullPath: '/jogos/cadastrados'
      preLoaderRoute: typeof AdminJogosCadastradosRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/jogos/andamento': {
      id: '/_admin/jogos/andamento'
      path: '/jogos/andamento'
      fullPath: '/jogos/andamento'
      preLoaderRoute: typeof AdminJogosAndamentoRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/jogos/$id': {
      id: '/_admin/jogos/$id'
      path: '/jogos/$id'
      fullPath: '/jogos/$id'
      preLoaderRoute: typeof AdminJogosIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/docs/tokens': {
      id: '/_admin/docs/tokens'
      path: '/docs/tokens'
      fullPath: '/docs/tokens'
      preLoaderRoute: typeof AdminDocsTokensRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/docs/templates': {
      id: '/_admin/docs/templates'
      path: '/docs/templates'
      fullPath: '/docs/templates'
      preLoaderRoute: typeof AdminDocsTemplatesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/docs/seguranca': {
      id: '/_admin/docs/seguranca'
      path: '/docs/seguranca'
      fullPath: '/docs/seguranca'
      preLoaderRoute: typeof AdminDocsSegurancaRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/docs/jogos': {
      id: '/_admin/docs/jogos'
      path: '/docs/jogos'
      fullPath: '/docs/jogos'
      preLoaderRoute: typeof AdminDocsJogosRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/docs/auth': {
      id: '/_admin/docs/auth'
      path: '/docs/auth'
      fullPath: '/docs/auth'
      preLoaderRoute: typeof AdminDocsAuthRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/docs/api-integracao': {
      id: '/_admin/docs/api-integracao'
      path: '/docs/api-integracao'
      fullPath: '/docs/api-integracao'
      preLoaderRoute: typeof AdminDocsApiIntegracaoRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/alertas/entregas': {
      id: '/_admin/alertas/entregas'
      path: '/entregas'
      fullPath: '/alertas/entregas'
      preLoaderRoute: typeof AdminAlertasEntregasRouteImport
      parentRoute: typeof AdminAlertasRoute
    }
    '/_admin/alertas-seguranca/preferencias': {
      id: '/_admin/alertas-seguranca/preferencias'
      path: '/alertas-seguranca/preferencias'
      fullPath: '/alertas-seguranca/preferencias'
      preLoaderRoute: typeof AdminAlertasSegurancaPreferenciasRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/alertas-seguranca/$id': {
      id: '/_admin/alertas-seguranca/$id'
      path: '/alertas-seguranca/$id'
      fullPath: '/alertas-seguranca/$id'
      preLoaderRoute: typeof AdminAlertasSegurancaIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/lotep/estruturas/': {
      id: '/_admin/lotep/estruturas/'
      path: '/lotep/estruturas'
      fullPath: '/lotep/estruturas/'
      preLoaderRoute: typeof AdminLotepEstruturasIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/kyc/review/': {
      id: '/_admin/kyc/review/'
      path: '/review'
      fullPath: '/kyc/review/'
      preLoaderRoute: typeof AdminKycReviewIndexRouteImport
      parentRoute: typeof AdminKycRoute
    }
    '/_admin/temas/preview/$code': {
      id: '/_admin/temas/preview/$code'
      path: '/temas/preview/$code'
      fullPath: '/temas/preview/$code'
      preLoaderRoute: typeof AdminTemasPreviewCodeRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/kyc/review/$id': {
      id: '/_admin/kyc/review/$id'
      path: '/review/$id'
      fullPath: '/kyc/review/$id'
      preLoaderRoute: typeof AdminKycReviewIdRouteImport
      parentRoute: typeof AdminKycRoute
    }
    '/_admin/jogos/$id/dashboard': {
      id: '/_admin/jogos/$id/dashboard'
      path: '/dashboard'
      fullPath: '/jogos/$id/dashboard'
      preLoaderRoute: typeof AdminJogosIdDashboardRouteImport
      parentRoute: typeof AdminJogosIdRoute
    }
    '/_admin/lotep/estruturas/$structureId/pool': {
      id: '/_admin/lotep/estruturas/$structureId/pool'
      path: '/lotep/estruturas/$structureId/pool'
      fullPath: '/lotep/estruturas/$structureId/pool'
      preLoaderRoute: typeof AdminLotepEstruturasStructureIdPoolRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface AdminAlertasRouteChildren {
  AdminAlertasEntregasRoute: typeof AdminAlertasEntregasRoute
}

const AdminAlertasRouteChildren: AdminAlertasRouteChildren = {
  AdminAlertasEntregasRoute: AdminAlertasEntregasRoute,
}

const AdminAlertasRouteWithChildren = AdminAlertasRoute._addFileChildren(
  AdminAlertasRouteChildren,
)

interface AdminKycRouteChildren {
  AdminKycReviewIdRoute: typeof AdminKycReviewIdRoute
  AdminKycReviewIndexRoute: typeof AdminKycReviewIndexRoute
}

const AdminKycRouteChildren: AdminKycRouteChildren = {
  AdminKycReviewIdRoute: AdminKycReviewIdRoute,
  AdminKycReviewIndexRoute: AdminKycReviewIndexRoute,
}

const AdminKycRouteWithChildren = AdminKycRoute._addFileChildren(
  AdminKycRouteChildren,
)

interface AdminSaquesRouteChildren {
  AdminSaquesHistoricoRoute: typeof AdminSaquesHistoricoRoute
  AdminSaquesManualReviewRoute: typeof AdminSaquesManualReviewRoute
}

const AdminSaquesRouteChildren: AdminSaquesRouteChildren = {
  AdminSaquesHistoricoRoute: AdminSaquesHistoricoRoute,
  AdminSaquesManualReviewRoute: AdminSaquesManualReviewRoute,
}

const AdminSaquesRouteWithChildren = AdminSaquesRoute._addFileChildren(
  AdminSaquesRouteChildren,
)

interface AdminSeoRouteChildren {
  AdminSeoSlugRoute: typeof AdminSeoSlugRoute
  AdminSeoIndexRoute: typeof AdminSeoIndexRoute
}

const AdminSeoRouteChildren: AdminSeoRouteChildren = {
  AdminSeoSlugRoute: AdminSeoSlugRoute,
  AdminSeoIndexRoute: AdminSeoIndexRoute,
}

const AdminSeoRouteWithChildren = AdminSeoRoute._addFileChildren(
  AdminSeoRouteChildren,
)

interface AdminSorteiosRouteChildren {
  AdminSorteiosEncerradosRoute: typeof AdminSorteiosEncerradosRoute
  AdminSorteiosPendentesRoute: typeof AdminSorteiosPendentesRoute
}

const AdminSorteiosRouteChildren: AdminSorteiosRouteChildren = {
  AdminSorteiosEncerradosRoute: AdminSorteiosEncerradosRoute,
  AdminSorteiosPendentesRoute: AdminSorteiosPendentesRoute,
}

const AdminSorteiosRouteWithChildren = AdminSorteiosRoute._addFileChildren(
  AdminSorteiosRouteChildren,
)

interface AdminJogosIdRouteChildren {
  AdminJogosIdDashboardRoute: typeof AdminJogosIdDashboardRoute
}

const AdminJogosIdRouteChildren: AdminJogosIdRouteChildren = {
  AdminJogosIdDashboardRoute: AdminJogosIdDashboardRoute,
}

const AdminJogosIdRouteWithChildren = AdminJogosIdRoute._addFileChildren(
  AdminJogosIdRouteChildren,
)

interface AdminRouteChildren {
  AdminAfiliadosRoute: typeof AdminAfiliadosRoute
  AdminAlertasRoute: typeof AdminAlertasRouteWithChildren
  AdminAuditoriaRoute: typeof AdminAuditoriaRoute
  AdminBannersRoute: typeof AdminBannersRoute
  AdminBtagsRoute: typeof AdminBtagsRoute
  AdminCampanhasRoute: typeof AdminCampanhasRoute
  AdminChangePasswordRoute: typeof AdminChangePasswordRoute
  AdminCircuitBreakersRoute: typeof AdminCircuitBreakersRoute
  AdminConfiguracoesRoute: typeof AdminConfiguracoesRoute
  AdminDashboardRoute: typeof AdminDashboardRoute
  AdminDestaquesRoute: typeof AdminDestaquesRoute
  AdminEnviosRoute: typeof AdminEnviosRoute
  AdminEquipeRoute: typeof AdminEquipeRoute
  AdminFaturamentoRoute: typeof AdminFaturamentoRoute
  AdminFunilRoute: typeof AdminFunilRoute
  AdminIntegracoesRoute: typeof AdminIntegracoesRoute
  AdminIpSecurityRoute: typeof AdminIpSecurityRoute
  AdminKycRoute: typeof AdminKycRouteWithChildren
  AdminLeadsRoute: typeof AdminLeadsRoute
  AdminLogsRoute: typeof AdminLogsRoute
  AdminMeuPerfilRoute: typeof AdminMeuPerfilRoute
  AdminPremiosRoute: typeof AdminPremiosRoute
  AdminRelatoriosRoute: typeof AdminRelatoriosRoute
  AdminSaquesRoute: typeof AdminSaquesRouteWithChildren
  AdminSaudeSistemaRoute: typeof AdminSaudeSistemaRoute
  AdminSeoRoute: typeof AdminSeoRouteWithChildren
  AdminSorteiosRoute: typeof AdminSorteiosRouteWithChildren
  AdminTransacoesRoute: typeof AdminTransacoesRoute
  AdminAlertasSegurancaIdRoute: typeof AdminAlertasSegurancaIdRoute
  AdminAlertasSegurancaPreferenciasRoute: typeof AdminAlertasSegurancaPreferenciasRoute
  AdminDocsApiIntegracaoRoute: typeof AdminDocsApiIntegracaoRoute
  AdminDocsAuthRoute: typeof AdminDocsAuthRoute
  AdminDocsJogosRoute: typeof AdminDocsJogosRoute
  AdminDocsSegurancaRoute: typeof AdminDocsSegurancaRoute
  AdminDocsTemplatesRoute: typeof AdminDocsTemplatesRoute
  AdminDocsTokensRoute: typeof AdminDocsTokensRoute
  AdminJogosIdRoute: typeof AdminJogosIdRouteWithChildren
  AdminJogosAndamentoRoute: typeof AdminJogosAndamentoRoute
  AdminJogosCadastradosRoute: typeof AdminJogosCadastradosRoute
  AdminJogosEncerradosRoute: typeof AdminJogosEncerradosRoute
  AdminJogosModalidadesRoute: typeof AdminJogosModalidadesRoute
  AdminJogosNewRoute: typeof AdminJogosNewRoute
  AdminJogosTemplatesRoute: typeof AdminJogosTemplatesRoute
  AdminMediaPastasRoute: typeof AdminMediaPastasRoute
  AdminPresentationArchitectureRoute: typeof AdminPresentationArchitectureRoute
  AdminSegurancaIpAllowlistRoute: typeof AdminSegurancaIpAllowlistRoute
  AdminSegurancaSessoesRoute: typeof AdminSegurancaSessoesRoute
  AdminUsuariosIdRoute: typeof AdminUsuariosIdRoute
  AdminAlertasSegurancaIndexRoute: typeof AdminAlertasSegurancaIndexRoute
  AdminJogosIndexRoute: typeof AdminJogosIndexRoute
  AdminMediaIndexRoute: typeof AdminMediaIndexRoute
  AdminTemasIndexRoute: typeof AdminTemasIndexRoute
  AdminUsuariosIndexRoute: typeof AdminUsuariosIndexRoute
  AdminTemasPreviewCodeRoute: typeof AdminTemasPreviewCodeRoute
  AdminLotepEstruturasIndexRoute: typeof AdminLotepEstruturasIndexRoute
  AdminLotepEstruturasStructureIdPoolRoute: typeof AdminLotepEstruturasStructureIdPoolRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAfiliadosRoute: AdminAfiliadosRoute,
  AdminAlertasRoute: AdminAlertasRouteWithChildren,
  AdminAuditoriaRoute: AdminAuditoriaRoute,
  AdminBannersRoute: AdminBannersRoute,
  AdminBtagsRoute: AdminBtagsRoute,
  AdminCampanhasRoute: AdminCampanhasRoute,
  AdminChangePasswordRoute: AdminChangePasswordRoute,
  AdminCircuitBreakersRoute: AdminCircuitBreakersRoute,
  AdminConfiguracoesRoute: AdminConfiguracoesRoute,
  AdminDashboardRoute: AdminDashboardRoute,
  AdminDestaquesRoute: AdminDestaquesRoute,
  AdminEnviosRoute: AdminEnviosRoute,
  AdminEquipeRoute: AdminEquipeRoute,
  AdminFaturamentoRoute: AdminFaturamentoRoute,
  AdminFunilRoute: AdminFunilRoute,
  AdminIntegracoesRoute: AdminIntegracoesRoute,
  AdminIpSecurityRoute: AdminIpSecurityRoute,
  AdminKycRoute: AdminKycRouteWithChildren,
  AdminLeadsRoute: AdminLeadsRoute,
  AdminLogsRoute: AdminLogsRoute,
  AdminMeuPerfilRoute: AdminMeuPerfilRoute,
  AdminPremiosRoute: AdminPremiosRoute,
  AdminRelatoriosRoute: AdminRelatoriosRoute,
  AdminSaquesRoute: AdminSaquesRouteWithChildren,
  AdminSaudeSistemaRoute: AdminSaudeSistemaRoute,
  AdminSeoRoute: AdminSeoRouteWithChildren,
  AdminSorteiosRoute: AdminSorteiosRouteWithChildren,
  AdminTransacoesRoute: AdminTransacoesRoute,
  AdminAlertasSegurancaIdRoute: AdminAlertasSegurancaIdRoute,
  AdminAlertasSegurancaPreferenciasRoute:
    AdminAlertasSegurancaPreferenciasRoute,
  AdminDocsApiIntegracaoRoute: AdminDocsApiIntegracaoRoute,
  AdminDocsAuthRoute: AdminDocsAuthRoute,
  AdminDocsJogosRoute: AdminDocsJogosRoute,
  AdminDocsSegurancaRoute: AdminDocsSegurancaRoute,
  AdminDocsTemplatesRoute: AdminDocsTemplatesRoute,
  AdminDocsTokensRoute: AdminDocsTokensRoute,
  AdminJogosIdRoute: AdminJogosIdRouteWithChildren,
  AdminJogosAndamentoRoute: AdminJogosAndamentoRoute,
  AdminJogosCadastradosRoute: AdminJogosCadastradosRoute,
  AdminJogosEncerradosRoute: AdminJogosEncerradosRoute,
  AdminJogosModalidadesRoute: AdminJogosModalidadesRoute,
  AdminJogosNewRoute: AdminJogosNewRoute,
  AdminJogosTemplatesRoute: AdminJogosTemplatesRoute,
  AdminMediaPastasRoute: AdminMediaPastasRoute,
  AdminPresentationArchitectureRoute: AdminPresentationArchitectureRoute,
  AdminSegurancaIpAllowlistRoute: AdminSegurancaIpAllowlistRoute,
  AdminSegurancaSessoesRoute: AdminSegurancaSessoesRoute,
  AdminUsuariosIdRoute: AdminUsuariosIdRoute,
  AdminAlertasSegurancaIndexRoute: AdminAlertasSegurancaIndexRoute,
  AdminJogosIndexRoute: AdminJogosIndexRoute,
  AdminMediaIndexRoute: AdminMediaIndexRoute,
  AdminTemasIndexRoute: AdminTemasIndexRoute,
  AdminUsuariosIndexRoute: AdminUsuariosIndexRoute,
  AdminTemasPreviewCodeRoute: AdminTemasPreviewCodeRoute,
  AdminLotepEstruturasIndexRoute: AdminLotepEstruturasIndexRoute,
  AdminLotepEstruturasStructureIdPoolRoute:
    AdminLotepEstruturasStructureIdPoolRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  AcceptInviteRoute: AcceptInviteRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  Setup2faRoute: Setup2faRoute,
  Verify2faRoute: Verify2faRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
